import axios from 'axios'

import { getAccessToken, removeAccessToken } from '@/helpers/auth-helper'

import { useAuthorizationStore } from '@/store/authorizationStore'

const axiosExportGoApi = axios.create({
    baseURL: `${import.meta.env.VITE_API_EXPORT_GO_URL}/api/`,
})

axiosExportGoApi.interceptors.request.use(
    (config) => {
        const token = getAccessToken()
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },

    (error) => Promise.reject(error),
)

axiosExportGoApi.interceptors.response.use(
    (response) => {
        if (response.headers['content-type'].indexOf('text/csv;') + 1) {
            return Promise.resolve(response)
        }

        if (response.headers['content-type'].indexOf('text/plain;') + 1) {
            return Promise.resolve(response)
        }

        if (response.headers['content-type'].indexOf('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') + 1) {
            return Promise.resolve(response)
        }

        return Promise.resolve(response.data)
    },

    (error) => {
        if (error?.response?.status) {
            const authorizationStore = useAuthorizationStore()

            switch (error.response.status) {
            case 401:
                removeAccessToken()
                authorizationStore.$reset()
                break
            }
        }

        const message = error?.response ? error.response.data.message : error.message
        return Promise.resolve({
            success: false,
            message,
        })
    },
)

export default axiosExportGoApi
